













































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { EventUI } from '../models/event-ui';
import DynamicFormField from './DynamicFormField.vue';

@Component({
  components: {
    DynamicFormField,
  },
})
export default class EventCardComponent extends Vue {
  @Prop({ required: true })
  eventUi!: EventUI;

  favorite() {
    this.eventUi.favorite();
    this.$emit('on-favorite', this.eventUi);
  }

  select() {
    this.$emit('on-select', this.eventUi);
  }

  // decrease() {}

  // increase() {}

  get event_info_place(): string {
    return typeof this.eventUi.event.info.place === 'string'
      ? this.eventUi.event.info.place
      : this.eventUi.event.info.place?.name || '';
  }
}
